import type { AgGridReact } from "@jsq/ds/core";

export const defaultGridOptions: AgGridReact.AgGridReactProps["gridOptions"] = {
  pagination: true,
  paginationPageSize: 20,
  domLayout: "normal",
  suppressCellFocus: true,
  rowHeight: 52,
  defaultColDef: {
    wrapHeaderText: true,
    autoHeaderHeight: true,
  },
};
